import {Component, HostListener, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute, NavigationEnd, Router} from '@angular/router';
import {RestService} from '../services/rest.service';
import {UIBlockerService} from '../services/uiblocker.service';
import {DataService} from '../services/data.service';
import {SessionStorageService} from '../services/session-storage.service';
import {filter, finalize, map, tap} from 'rxjs/operators';
import {Subscription} from 'rxjs';

@Component({
    selector: 'app-central',
    templateUrl: './central.component.html',
    styleUrls: ['./central.component.css']
})
export class CentralComponent implements OnInit, OnDestroy {

    sessionId: any;
    userInfo: any;
    pageName: any;
    isMobileSidebarOpen = false;
    dataChangedSessionSubscription: Subscription;

    constructor(private restService: RestService,
                private uiBlockerService: UIBlockerService,
                private router: Router,
                private activatedRoute: ActivatedRoute,
                private dataService: DataService,
                private localStorage: SessionStorageService) { /* noop */
    }

    ngOnInit() {
        this.dataChangedSessionSubscription = this.dataService.dataChangedSession.subscribe(() => {
            this.userInfo = this.dataService.getUserInfo();
        });
        this.getDataFromLocalStorage();
        this.getPageNameForRefresh();
        this.getPageNameDataDynamic();
    }

    ngOnDestroy() {
        if (this.dataChangedSessionSubscription) {
            this.dataChangedSessionSubscription.unsubscribe();
        }
    }

    getDataFromLocalStorage() {
        this.localStorage.getItem('SessionIdentifier').subscribe((data) => {
            // if we find a value we will quickly make a new api call to get guardion details (email and name) to

            // have them
            if (data === null || data === '') {
                // we do not have the session id so just stay on the login page - nithing else needed
            } else {
                // we have the sesion id so we will call the new check session id on blackhole
                this.checkSessionIdOnServer(data);
            }
        });
    }

    getPageNameDataDynamic() {
        this.router
            .events.pipe(
            filter((event) => event instanceof NavigationEnd),
            map(() => {
                let child = this.activatedRoute.firstChild;
                while (child.firstChild) {
                    child = child.firstChild;
                }
                if (child.snapshot.data.title) {
                    return child.snapshot.data.title;
                }
                return this.pageName;
            })
        ).subscribe((ttl: string) => {
            this.pageName = ttl; // this will cover the case when the page is changing
            this.closeMobileSidebar();
        });
    }

    toggleMobileSidebar() {
        this.isMobileSidebarOpen = !this.isMobileSidebarOpen;
    }

    closeMobileSidebar() {
        this.isMobileSidebarOpen = false;
    }

    @HostListener('document:keydown.escape')
    onEscapeKey() {
        this.closeMobileSidebar();
    }

    getPageNameForRefresh() {
        let child = this.activatedRoute.firstChild;
        while (child.firstChild) {
            child = child.firstChild;
        }
        if (child.snapshot.data.title) {
            this.pageName = child.snapshot.data.title;
        }
    }

    checkSessionIdOnServer(data: any) {
        // check session id on server
        this.restService.checkSession(data)
            .pipe(
                finalize(() => {
                    this.uiBlockerService.unBlockUI();
                }),
                tap(
                    () => {
                        /* noop */
                    },
                    () => {

                        // we must clear the current local storage since that value is not good
                        this.localStorage.clear().subscribe(() => { /* noop */
                        });
                    }
                )
            ).subscribe((res: any) => {
            if (this.dataService.isResponseSuccessful(res)) {
                this.userInfo = res.UserInfo;
                // and now that we have the data we can redirect to the home page
                this.dataService.setUserInfo(res.UserInfo);
            } else {
                // manage response not valid so redirect to login
                this.router.navigate(['/login']);
            }
        });
    }

}
